export default {
    titulo: "Remitos",
    nuevo: "Nuevo remito",
    ver: "Ver remito",
    noHaySeries: "No se ingresaron series",
    verSeries: "Ver series",
    ingresarSeries: "Ingresar series",
    faltanSeries: "Faltan números de serie",
    msgRepuestos: "Agrega al menos un repuesto para continuar",
    msgCantidad: "Ingresa una cantidad válida",
    msgDuplicado: "Repuesto duplicado",
    msgStock: "Stock insuficiente",
    msgSerieInvalida: "Ingresa una serie válida"
}